<template>
  <div id="app" ref="infoBox" class="app">
    <notifications group="all" position="bottom right" class="ols-notification-wrapper" width="500">
      <template slot="body" slot-scope="props">
        <div :class="props.item.type" @click="props.close(); props.item.data.close()" style="padding:5px 10px; border-left:3px solid; cursor: pointer">
            <a class="title">{{props.item.title}}</a>
            <br>
            <br>
            <br>
            <br>
            <div v-html="props.item.text">
            </div>
            <br>
            <br>
            <br>
        </div>
      </template>
    </notifications>
    <a href="https://grupogeos.trb.ai/wa/161qkL2" target="_blank"><div class="notification" v-if="isVisible">Quiero contratar este seguro <img src="@/assets/icon-whatsapp.svg" alt=""></div></a>
    <router-view/>
  </div>
</template>

<script>
// import API from '@/api'

export default {
    name: 'App',
    metaInfo() {
        return {
            title: 'Interseguros',
            titleTemplate: '%s | Interseguros',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Somos asesores de seguros con más de 10 años de experiencia. Te ayudamos a elegir la mejor opción para ti. ¡Cotiza tu seguro ahora!'
            },
            {
                vmid: 'keywords',
                name: 'keywords',
                content: 'Asesor en riesgos laborales, intermediación ARL, Control de ARL, Seguros ARL, Administradora de Riesgo Laborales, Seguros Generales, Seguros Empresariales, Seguros Personales'
            },
            {
                vmid: 'image',
                name: 'image',
                content: require('@/assets/logo/logo.webp')
            },
            {
                vmid: 'robots',
                name: 'robots',
                content: 'index, follow'
            },
            {
                vmid: 'twitter:card',
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                vmid: 'twitter:title',
                name: 'twitter:title',
                content: 'Interseguros'
            },
            {
                vmid: 'twitter:site',
                name: 'twitter:site',
                content: '@Interseguros'
            },
            {
                vmid: 'twitter:description',
                name: 'twitter:description',
                content: 'Somos asesores de seguros con más de 10 años de experiencia. Te ayudamos a elegir la mejor opción para ti. ¡Cotiza tu seguro ahora!'
            },
            {
                vmid: 'twitter:image',
                name: 'twitter:image',
                content: require('@/assets/image-people.png')
            }]
        }
    },
    data() {
        return {
            isVisible: false
        }
    },
    methods: {
        handleScroll() {
            if (window.scrollY > 250 && this.$route.fullPath.split('/')[1] === 'servicios') {
                this.isVisible = true
            } else {
                this.isVisible = false
            }
        }
    },
    created () {
        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>
@font-face {
font-family: 'JR';
src: url('./assets/fonts/Jost-Regular.ttf') format('truetype');
font-display: auto;
}

@font-face {
font-family: 'JBD';
src: url('./assets/fonts/Jost-Bold.ttf') format('truetype');
font-display: auto;
}

@font-face {
font-family: 'JLI';
src: url('./assets/fonts/Jost-LightItalic.ttf') format('truetype');
font-display: auto;
}

body {
    width: 100%;
}

.hbspt-form > {
    width: 100%;
}
.hbspt-form > form > .form-columns-2{
    width: 100%;
}
</style>

<style scoped>
    .notification {
        width: 150px;
        margin-left: 90px;
        margin-top: 60px;
        position: fixed;
        bottom: 80px;
        left: 20px;
        background-color: #2d4f98;
        padding: 5px;
        z-index: 9999999999999;
        font-family: 'JBD';
        color: #fff;
        border-style: solid;
        border-color: #65b24a;
        border-top-right-radius: 20px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
    }
    .notification > img {
        width: 30px;
    }
    .dirty {
    border-color: #5A5 !important;
    background: #EFE !important;
    width: 100%;
    }

    .dirty:focus {
    outline-color: #8E8 !important;
    }

    .error {
    border-color: red !important;
    background: #FDD !important;
    }

    .error:focus {
    outline-color: #F99 !important;
    }

    .error-mess {
    margin-top: -1.5em;
    position: absolute;
    color: #FF0000;
    }

    @media (max-width: 768px) {
    .ols-notification-wrapper {
        bottom: 0px!important;
        position: fixed!important;
        top: unset!important;
    }
    html {
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    }

    @media screen and (max-width: 800px) {
    .ols-notification-wrapper {
        display: flex;
        width: 100% !important;
        margin-left: 0 !important;
        left: 0 !important;
        justify-content: center;
    }
    .notification-wrapper {
        font-size: 10px;
    }
    .modal-dialog {
        margin-top: 80px;
    }
    }

</style>



// WEBPACK FOOTER //
// src/App.vue